module.exports = __webpack_public_path__ + "static/img/Saipa_banner1_Far.f448a03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Saipa_banner1_Far.png
// module id = 14
// module chunks = 1